//@ts-nocheck

'use client'

import React from "react";
import * as S from "./MenuMobile.styles";

import Button from "../../../atoms/Button/Button.component";
import MenuItem from "../MenuItem/MenuItem.component";
import MenuContent from "../MenuContent/MenuContent.component";

const MenuMobile = ({ 
  headerMenu, 
  isOpen, 
  serviceMenu, 
  submenu, 
  setSubmenu, 
  data,
  handleOpenMenu,
  handleCloseMenu,
  isSubmenuOpen,
  setIsSubmenuOpen
}) => {
  return (
    <S.MenuMobile isOpen={isOpen}>
      <S.MenuMobileFirstLevel>
        {headerMenu.map((item, idx) => {
          if (item.withSubmenu) {
            return (
              <MenuItem 
                title={item.label}
                description={item.description}
                key={`header-menu-item-${idx}`} 
                handleClick={() => {
                  if (item.label) handleOpenMenu(item.label)
                  setIsSubmenuOpen(true)
                }}
              />
            )
          } else if (item.isPrimary) {
            return (
              <Button
                href={item.href}
                label={item.label}
                variant={'primary'}
                key={`header-menu-item-${idx}`}
                iconEnd={'arrow-right'}
              />
            )
          } else {
            return (
              <MenuItem
                href={item.href}
                title={item.label}
                description={item.description}
                key={`header-menu-item-${idx}`}
              />
            )
          }
        })}
        <S.MenuMobileServiceWrapper>
          {serviceMenu.map(({ cta }, idx) => (
            <MenuItem
              title={cta.label}
              href={cta.href}
              key={`header-menu-item-${idx}`}
            />
          ))}
        </S.MenuMobileServiceWrapper>
      </S.MenuMobileFirstLevel>
      <S.MenuMobileSecondLevel isOpen={isSubmenuOpen}>
        {submenu && (
          <MenuContent
            data={data}
            isOpen={isOpen}
            submenu={submenu}
            handleGoBack={() => setIsSubmenuOpen(false)}
            handleCloseMenu={handleCloseMenu}
          />
        )}
      </S.MenuMobileSecondLevel>
    </S.MenuMobile>
  )
}

export default MenuMobile